import { PriceData, UpdatePriceDto } from '../../types';
import { useMemo, useState } from 'react';
import { useAlert } from '../../../../../../context/Alert.context';

interface useRowProps {
  item: UpdatePriceDto;
  onSave:(data: PriceData) => Promise<void>;
}

export const useRow = ({ item, onSave }: useRowProps) => {
  const priceString = item.price + ''
  const oldPriceString = item.oldPrice + ''
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState<string>(priceString);
  const [basePrice, setBasePrice] = useState<string>(priceString);
  const [baseOldPrice, setBaseOldPrice] = useState<string>(oldPriceString);
  const [oldPrice, setOldPrice] = useState<string>(oldPriceString);
  const oldPriceChange = (value: string) => {
    setOldPrice(value);
  };

  const priceChange = (value: string) => {
    setPrice(value);
  };

  const isDisabled = useMemo(
    () => price === basePrice && oldPrice === baseOldPrice,
    [price, oldPrice, basePrice, baseOldPrice],
  );

  const onSaveHdl = async() => {
    setLoading(true);
    await onSave({oldPrice, price})
    setBasePrice(price);
    setBaseOldPrice(oldPrice);
    setLoading(false);
  }


  return {
    loading,
    oldPrice,
    price,
    isDisabled,
    oldPriceChange,
    priceChange,
    onSaveHdl
  }
}